export default "__VITE_ASSET__ba548bab__"